var _style, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoltx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0 {\n      fill: url(#SVGID_1_);\n    }\n    .st1 {\n      fill: #464AEB;\n    }\n  ")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 30,
    y2: 40,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1747,
    style: {
      stopColor: "#454AEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61C2ED"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.233900219169623,2.7094458621705746 l-13.560138397070807,15.444850773558986 c-0.24476784110236113,0.24476784110236113 -0.024476784110236148,0.6608731709763758 0.31819819343306965,0.6608731709763758 h3.2309355025511666 c0.3426749775433061,0 0.5384892504251947,0.41610532987401433 0.2937214093228337,0.7098267391968476 l-17.67223812759047,18.18625059390543 c-0.09790713644094456,0.09790713644094456 0.024476784110236148,0.2937214093228337 0.14686070466141674,0.171337488771653 l30.057490887369944,-19.507996935858177 c0.3426749775433061,-0.2202910569921253 0.171337488771653,-0.7343035233070836 -0.2202910569921253,-0.7343035233070836 h-6.437394220992098 c-0.3916285457637782,0 -0.5629660345354306,-0.4895356822047223 -0.24476784110236113,-0.7098267391968476 l16.423922137968425,-13.706999101732222 c0.6363963868661391,-0.5384892504251947 0.24476784110236113,-1.5909909671653475 -0.5629660345354306,-1.5909909671653475 h-9.448038666551138 C28.653553697563307,1.6569441454304208 27.845819821925524,2.0485726911941993 27.233900219169623,2.7094458621705746 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.10882778590107,9.194082010665369 l-4.9744137138294064,-6.28976349392853 c-0.5978862636814197,-0.7174635164177036 -1.458842483382663,-1.1718570768155814 -2.3915450547256767,-1.1718570768155814 h-9.709672922186247 c-0.7174635164177036,0 -1.1479416262683246,0.8370407691539871 -0.693548065870447,1.4110115822881493 l11.001107251738112,13.799214965767153 L18.10882778590107,9.194082010665369 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.567670269283738,27.250247173844226 l7.4377051201968545,9.350941163977396 c0.5978862636814197,0.7174635164177036 1.4827579339299197,1.1718570768155814 2.415460505272933,1.1718570768155814 h9.39877206507191 c0.7174635164177036,0 1.1479416262683246,-0.8609562197012435 0.693548065870447,-1.4110115822881493 l-11.479416262683246,-14.564509383279368 L19.567670269283738,27.250247173844226 z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltx);
export default __webpack_public_path__ + "static/media/boltx.debb48e0a613667b6b1df9a44367d669.svg";
export { ForwardRef as ReactComponent };